import colors from './colors.json';

export const { YELLOW } = colors;
export const { DARK_YELLOW } = colors;
export const { LIGHT_YELLOW } = colors;
export const { DARKEST_YELLOW } = colors;
export const { BLACK } = colors;
export const { DARK_BLUE } = colors;
export const { DARKEST_BLUE } = colors;
export const { MIDNIGHT_BLUE } = colors;
export const { SOME_KIND_OF_BLUE } = colors;
export const { EVIL_BLUE } = colors;
export const { PALE_BLUE } = colors;
export const { ICY_BLUE } = colors;
export const { MIDDLE_BLUE } = colors;
export const { LIGHT_BLUE } = colors;
export const { BABY_BLUE } = colors;
export const { SKY_BLUE } = colors;
export const { GREY_BLUE } = colors;
export const { GARGOYLE_GREY } = colors;
export const { LIGHTER_GREY } = colors;
export const { WHITE } = colors;
export const { GREY } = colors;
export const { SUPER_LIGHT_GREY } = colors;
export const { LIGHT_GREY } = colors;
export const { WHITE_GREY } = colors;
export const { DARK_GREY } = colors;
export const { ORANGE } = colors;
export const { TURQUOISE } = colors;
